import axios from "axios";
import * as actionCreators from "./index";

export const setWebcrawlLoading = (isLoading) => {
	return {
		type: "[WEBCRAWL] SET_IS_LOADING",
		isLoading,
	};
};

export const setWebcrawlData = (data) => {
	return {
		type: "[WEBCRAWL] SET_DATA",
		data,
	};
};

export const setWebcrawlError = (error) => {
	return {
		type: "[WEBCRAWL] SET_ERROR",
		error,
	};
};

export const setWebcrawlFormData = (formData) => {
	return {
		type: "[WEBCRAWL] SET_FORM_DATA",
		formData,
	};
};

export const resetWebcrawlState = () => {
	return {
		type: "[WEBCRAWL] RESET_STATE",
	};
};

export const analyzeWebsite = (payload, signal) => {
	return async (dispatch, getState) => {
		try {
			dispatch(setWebcrawlLoading(true));
			dispatch(setWebcrawlError(null));

			const result = await axios.post(
				process.env.REACT_APP_NODE_URL + "/api/crawler/analyze",
				payload,
				{
					headers: {
						Authorization: "Bearer " + getState().auth.token,
						"Content-Type": "application/json"
					},
					signal,
				}
			);

			// Debug: Log the full response to check if text is truncated
			console.log("Full API Response:", result.data);
			if (result.data.pages && result.data.pages.length > 0) {
				console.log("First page extractedText length:", result.data.pages[0].extractedText?.length);
				console.log("First page extractedText (first 500 chars):", result.data.pages[0].extractedText?.substring(0, 500));
			}

			dispatch(setWebcrawlData(result.data));
		} catch (error) {
			if (axios.isCancel(error) || error.name === "AbortError") {
				dispatch(setWebcrawlLoading(false));
				return;
			}
			const errorMessage = error.response?.data?.message ||
				error.message ||
				"Something went wrong while analyzing the website";
			dispatch(setWebcrawlError(errorMessage));
			dispatch(
				actionCreators.showErrorModal(errorMessage)
			);
		} finally {
			dispatch(setWebcrawlLoading(false));
		}
	};
};
